// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.memberDiv .member-creation-form label {
  font-family: "72-Condensed";
}

.memberDiv .reqLabel {
  color: red;
  font-style: italic;
}
.memberDiv .volumeslabel {
  font-size: 1.6rem;
  margin-top: auto;
  margin-bottom: auto;
}
.memberDiv .memberCreated {
  margin-left: auto;
  margin-right: auto;
  width: 30rem;
  height: 5rem;
  background-color: #FDE0A9;
  display: flex;
  justify-content: center;
}
.memberDiv .memberCreated .memberCreatedlabel {
  margin-top: auto;
  margin-bottom: auto;
}
.memberDiv .formClass {
  margin-left: auto;
  margin-right: auto;
}
.memberDiv .saveButton {
  background-color: #00a7e3; /* Green */
  border: none;
  color: white;
  padding: 1.5rem 3.2rem;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1.6rem;
  cursor: pointer;
}
.memberDiv .cancelButton {
  background-color: Transparent;
  background-repeat: no-repeat;
  border: none;
  color: #00a7e3;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  font-size: 1.6rem;
}
.memberDiv .membertable {
  border-right: 0.1rem solid #e9e9e9;
  border-left: 0.1rem solid #e9e9e9;
  font-size: 1.1rem;
  line-height: 2.6rem;
  padding-top: 1rem;
}
.memberDiv .membertable .memberTableHeader {
  background-color: #e9e9e9;
}
.memberDiv .membertable .memberTableData {
  border-bottom: 0.1rem solid #e9e9e9;
}
.memberDiv .membertable .memberTableData .memberName {
  color: #1FAFEB;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/components/demo/demo.component.scss"],"names":[],"mappings":"AAIA,gHAAA;AAaA;EACI,2BAAA;ACfJ;;AADI;EACI,UAAA;EACA,kBAAA;AAIR;AADI;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AAGR;AAAI;EACI,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AAER;AAAQ;EACI,gBAAA;EACA,mBAAA;AAEZ;AAEI;EACI,iBAAA;EACA,kBAAA;AAAR;AAOI;EACI,yBAAA,EAAA,UAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;AALR;AAQI;EACI,6BAAA;EACA,4BAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AANR;AASI;EACI,kCAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AAPR;AASQ;EACI,yBAAA;AAPZ;AAUQ;EACI,mCAAA;AARZ;AAUY;EACI,cAAA;AARhB","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n.memberDiv{\n    .reqLabel{\n        color: red;\n        font-style: italic;\n    }\n\n    .volumeslabel{\n        font-size: 1.6rem;\n        margin-top: auto;\n        margin-bottom: auto;\n    }\n\n    .memberCreated{\n        margin-left: auto;\n        margin-right: auto;\n        width: 30rem;\n        height: 5rem;\n        background-color: #FDE0A9;\n        display: flex;\n        justify-content: center;\n\n        .memberCreatedlabel{                         \n            margin-top: auto;\n            margin-bottom: auto;\n        }\n    }\n\n    .formClass{\n        margin-left: auto;\n        margin-right: auto;\n    }\n\n    .member-creation-form label{\n        @extend %font-condensed;\n    }\n\n    .saveButton{\n        background-color: #00a7e3; /* Green */\n        border: none;\n        color: white;\n        padding: 1.5rem 3.2rem;\n        text-align: center;\n        text-decoration: none;\n        display: inline-block;\n        font-size: 1.6rem;\n        cursor: pointer;\n    }\n\n    .cancelButton{\n        background-color: Transparent;\n        background-repeat:no-repeat;\n        border: none;\n        color: #00a7e3;\n        cursor:pointer;\n        overflow: hidden;\n        outline:none;\n        font-size: 1.6rem;\n    }\n\n    .membertable{\n        border-right: 0.1rem solid #e9e9e9;\n        border-left: 0.1rem solid #e9e9e9;\n        font-size: 1.1rem;\n        line-height: 2.6rem;  \n        padding-top: 1rem;   \n\n        .memberTableHeader{\n            background-color: #e9e9e9;            \n        }\n\n        .memberTableData{\n            border-bottom: 0.1rem solid #e9e9e9;\n\n            .memberName{\n                color: #1FAFEB;\n            }\n        }\n    }    \n\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
